import styled, { css } from 'styled-components';
import { ReactComponent as BackIcon } from 'styles/icons/back.svg';
import arrow, { ReactComponent as Arrow } from 'styles/icons/arrow.svg';
import { animated } from 'react-spring';
import { normalize, withModifiers } from 'utils/styles';
import { color, typography } from 'styles/settings';

const caret = css`
  :not(:last-child):after {
    display: inline-block;
    color: ${color.neutral.plainBlack};
    position: relative;
    width: 10px;
    height: 10px;
    top: 1px;
    left: 3px;
    content: '';
    background: url('${arrow}');
    background-repeat: no-repeat;
    background-size: 100%;
    transform: rotate(90deg);
  }
`;

export const BackButton = styled(BackIcon)`
  color: ${color.brand.gold};
  cursor: pointer;
`;

export const BreadcrumbContainer = styled(animated.div)`
    display: flex;
    height: 54px;
    margin-left: 3px;
    padding: ${normalize('15px')} ${normalize('20px')};
    border-radius: 10px 2px 2px 2px;
    box-sizing: border-box;
    background-color ${color.neutral.white};
`;

export const Separator = styled.div`
  background-color: ${color.ui.backgroundGray};
  height: ${normalize('26px')};
  width: ${normalize('1px')};
  margin: 0 20px 0 20px;
`;

export const CurrentSurfaceName = styled.span`
  max-width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Surface = styled.div`
  ${typography.font.content.semiBold};
  font-size: ${typography.size.rg};
  color: ${color.neutral.plainBlack};
  height: 18px;
  line-height: 18px;
  margin-right: 8px;
  cursor: pointer;
  transition: color 0.2s;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  :hover {
    color: ${color.neutral.grayPale};
  }
`;

export const Tail = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${Surface} {
    ${caret}
  }

  > *:first-child {
    user-select: none;
  }

  > *:last-child {
    cursor: default;
    color: ${color.neutral.grayPale};
  }
`;

export const Decoration = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${color.neutral.white};
  transform: rotate(45deg);
  position: absolute;
  top: -5px;
  left: 30px;
  z-index: -2;
`;

export const DropdownMenu = styled.div`
position: relative;
top: 25px;
left: 55px;
margin-right: 55px;
background-color ${color.neutral.white};
padding: 16px 20px 5px 20px;

> * {
    margin-bottom: 12px;
}
`;

export const ArrowIcon = styled(Arrow)`
  margin-left: ${normalize('10px')};
  height: ${normalize('14px')};
  width: ${normalize('14px')};
  padding: ${normalize('4px')};
  transition-property: transform;
  transition-duration: 0.5s;

  ${withModifiers('$showDropdown')`
transform: rotate(180deg);
`}
`;
